import * as Sentry from '@sentry/react';

export const initializeSentry = () => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.log('Sentry DSN not configured, skipping initialization');
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    beforeSend(event) {
      // Filter out non-error events in development
      if (import.meta.env.DEV && event.level !== 'error') {
        return null;
      }
      return event;
    },
  });
};

export const logError = (error: Error, context?: Record<string, any>) => {
  Sentry.captureException(error, {
    contexts: {
      additional: context,
    },
  });
};

export const logMessage = (message: string, level: 'info' | 'warning' | 'error' = 'info') => {
  Sentry.captureMessage(message, level);
};